define((require) => {
    "use strict";

    const _     = require("underscore");
    const Class = require("shared/util/Class");

    /**
     * Represents a specific font provider.
     *
     * @class FontProvider
     * @author Kim
     */
    const FontProvider = Class.extend({

        /**
         * Constructor.
         *
         * @param  {String} value The enum value.
         * @param  {String} name  The name, as a display-friendly version, e.g. "Standard Fonts".
         */
        constructor(value, name) {
            this.value = value;
            this.name = name;
        },

        toString() {
            return `FontProvider[${this.value}]`;
        }
    }, {

        /**
         * Returns an array of all the enums.
         *
         * @return {FontProvider[]} Array of <tt>FontProvider</tt>'s.
         */
        all() {
            const providers = [];

            let value;

            for (const p in FontProvider) {
                value = FontProvider[p];

                if (value instanceof FontProvider) {
                    providers.push(value);
                }
            }

            return providers;
        },

        /**
         * Returns the proper <tt>FontProvider</tt> for the specified value string.
         *
         * @param  {String} value The value string.
         * @return {FontProvider} The matching <tt>FontProvider</tt>.
         */
        fromValue(value) {
            return _.find(FontProvider.all(), (item) => item.value === value);
        }
    });

    FontProvider.CUSTOM = new FontProvider("custom", "Custom Fonts");
    FontProvider.FONTS_DOT_COM = new FontProvider("fontsDotCom", "Fonts.com");
    FontProvider.GOOGLE = new FontProvider("google", "Google Fonts");
    FontProvider.STANDARD = new FontProvider("standard", "Standard Fonts");
    FontProvider.TYPEKIT = new FontProvider("typekit", "Typekit");

    return FontProvider;
});



// WEBPACK FOOTER //
// ./src/shared/data/fonts/FontProvider.js